import type { Action } from 'redux';
import type { UpdateConfigRequestActionPayload, UpdateConfigResponseActionPayload } from '../AdPartner.types';

export const UPDATE = 'AD_PARTNER_UPDATE';

export function updateConfig({ config }: UpdateConfigRequestActionPayload): UpdateConfigAction {
  return {
    type: UPDATE,
    data: config,
  };
}

export type UpdateConfigAction = Action<typeof UPDATE> & { data: UpdateConfigResponseActionPayload };
